import axios from "axios";
import { auth } from "../firebase";

const handleUnAuthError = (err) => {
  if (err.message === "Request failed with status code 401") {
    if (auth.currentUser) {
      auth.signOut();
    }
  }
};

const getToken = async () => {
  let tokenId;
  if (auth.currentUser) {
    tokenId = await auth.currentUser.getIdToken();
  }
  return tokenId;
};

export async function fetchData(method, url, body, callback, errorCallback) {
  // const tokenId = GlobalStore.get("token");
  const tokenId = await getToken();
  const timezoneoffset = new Date().getTimezoneOffset();
  axios({
    method,
    url,
    data: body,
    headers: {
      authorization: tokenId,
      timezoneoffset,
    },
  })
    .then((res) => {
      const { data } = res;
      callback(data);
    })
    .catch((err) => {
      handleUnAuthError(err);
      errorCallback(err);
    });
}

export const makeRequest = ({ url, method, data, authorization }) => {
  const timezoneoffset = new Date().getTimezoneOffset();
  return axios({
    method,
    url,
    data,
    headers: { authorization, timezoneoffset },
  }).catch(handleUnAuthError);
};
